export default __webpack_public_path__ + "static/media/Trillium-480px-180px.jpg.233d85bd.webp";